import Rules from "../rules.js";
import Utils from "../utils.js";

class PresApply {
  constructor() {}
  setup() {
    window.Apply = (group, country, higherEducation, lang) => (
      `
      ${ApplyBox(group, country, higherEducation, lang)}

      ${Header(i18n.titleApplyAfter)}

      ${Reprioritize(group, lang)}
      ${Ranking(lang)}
      ${GetResults(group, lang)}
      ${Recognition(lang)}

      ${Contact(lang)}
      `
    )
    
    function ApplyBox(group, country, higherEducation, lang) {
      var date = new Date();
      return (
        `<div class="admission-box">
          <h2>${i18n.titleApply}</h2>` +
          (!Utils.checkWithinRange(date) ? `<p>${rangeOpen()}.</p>` : ``) +
          `${ExportRequirements(lang)}
          ${applyGuidelines(lang)}
          ${applyParttime(group, lang)}
          <p class="vrtx-date-info">&nbsp;</p>` +
          (Utils.checkWithinRange(date) ? (
             (group != "SFMASTER" ? `<p class="admission-apply">${ButtonFocus(GotoSoknadsweb(country, higherEducation, lang), i18n.btnGo, "btn-soknadsweb")}</p>`
                                  : `<p class="admission-apply">${ButtonFocus(GotoPreApplication(country, higherEducation, lang), i18n.btnGoSFMASTER, "btn-soknadsweb")}</p>`)
             )
          : ``) +
        `</div>`
      );
    }

    function applyGuidelines(lang) {
      var html = "";
      var text = Fellestekst("studiet-master-soke-hjelp", "studiet-master-soke-hjelp", lang, true);
      if(text) html += AccordionHeader(i18n.titleApplyGuidelines) + text;
      return html;
    }

    function applyParttime(group, lang) {
      var html = "";
      if(Rules.showPartTime()) {
        var text = Fellestekst("studiet-master-soke-hjelp", "studiet-master-soke-assessment-" + group, lang);
        if(text) html += AccordionHeader(i18n.titleApplyParttime) + text;
      }
      return html;
    }

    function ExportRequirements(lang) {
      var html = "";
      var text = Fellestekst("opptak-master-eksportkontroll", App.program.fellestekst["opptak-master-eksportkontroll"], lang);

      if(text) html += AccordionHeader(i18n.exportControlRequirements) + text;
      return html;
    }

    // Unntak for helseadm 1 mars.

    function Reprioritize(group, lang) {
      var html = "";
      if(!Rules.showFinancingExtraEMHEM(group)) {
        var text = Fellestekst("studiet-master-etter-soknad", "studiet-master-omprio-" + (group === "SFMASTER" ? "SFMASTER" : "UIOMASTER-EUMAS"), lang);
        if(text && (text.indexOf("###DATE-REPRIORITIZE###") === -1 || App.date[0].reprioritize)) {
          html = AccordionHeader(i18n.titleReprioritize) + Utils.InfoDate(text, "###DATE-REPRIORITIZE###", "reprioritize");  
        }
      }
      return html;
    }

    function GetResults(group, lang) {
      var html = "";
      var text = Fellestekst("studiet-master-etter-soknad", "studiet-master-svar", lang);
      if(text && (text.indexOf("###DATE-GETTING-RESULTS###") === -1 || App.date[0]["getting-results"])) {
        html = AccordionHeader(i18n.titleGetResults) + Utils.InfoDate(text, "###DATE-GETTING-RESULTS###", "getting-results");
      }
      return html;
    }

    function Ranking(lang) {
      var html = "";
      var text = Fellestekst("studiet-master-rangering", App.program.fellestekst["studiet-master-rangering"], lang);
      if(text) html += text;
      text = HeaderDowngrade(App.program["studiet-master-rangering-fri"]);
      if(text) html += text;
      if(html != "") html = AccordionHeader(i18n.titleRanking) + html;
      return html;
    }

    function Recognition(lang) {
      var html = "";
      var text = Fellestekst("studiet-master-innpassing-utd", App.program.fellestekst["studiet-master-innpassing-utd"], lang);
      if(text) html += text;
      text = HeaderDowngrade(App.program["studiet-master-innpassing-utd-fri"]);
      if(text) html += text;
      if(html != "") html = AccordionHeader(i18n.titleRecognition) + html;
      return html;
    }

    function Contact(lang) {
      var html = "";
      var text = Fellestekst("studiet-kontakt-hjelp", "studiet-kontakt-hjelp", lang);
      if(text) html += Header(i18n.titleContact) + text;
      return html;
    }

    function GotoSoknadsweb(country, higherEducation, lang) {
      return "https://fsweb.no/soknadsweb/login.jsf?inst=uio";
    }

    function GotoPreApplication(country, higherEducation, lang) {
      return "/english/studies/admission/master/pre-application/";
    }

    function ApplyAfterRanking(group, lang) {
      var html = "";
      var text = Fellestekst("rangering-av-sokere", "ranking-masters-degree", lang);
      if(text) html += SubHeader(i18n.titleRanking) + text;
      return html;
    }

    function rangeOpen() {
      var text = i18n.outsideRange;
      text = Utils.InfoDateRange(text, "portal-opens", "deadline");
      return text;
    }

  }
}
export default new PresApply;